import {ThunkDispatch} from "redux-thunk"
import {
  MESSAGE_LIST_FAILED,
  MESSAGE_LIST_PENDING, MESSAGE_LIST_RECEIVE,
  OperationMessagesItem,
  OperationMessagesRootState, UPDATE_CUR_REPORT
} from "./types"
import {AnyAction} from "redux"
import {ajax} from "../../utils/ajax"
import {logAction} from "../../utils/log"
import {OPERATION_LIMIT} from "../../utils/config";

interface QueryParam {
  limit: number,
  until?: string
}

interface ResponseType {
  end: string,
  gender: number,
  operationMessages: OperationMessagesItem[],
  // 原始数据
  origin: {
    pagination: {
      links: {
        next: string;
        previous: string
      }
    }
  }
  since: string,
  thumbnail_url: string,
  token: string
}

const baseUrl = ''

// 获取运营消息列表
export const getOperationList = (init = false) => async (
  dispatch: ThunkDispatch<OperationMessagesRootState, void, AnyAction>,
  getState: () => OperationMessagesRootState
) => {
  await dispatch(requestPosts())
  logAction('actions-----------------------------------------------------------getOperationList')
  const {next} = getState().operationMessages.links
  // ?user_id=22957 | 26676
  let url: string = init ? `${baseUrl}/v2/users/me/operation-messages` : next
  logAction('url = ', url)
  const res = await ajax.request<any, ResponseType>({
    url, params: {
      limit: OPERATION_LIMIT,
    }
  })
  // 已读消息
  init
  && res.operationMessages
  && res.operationMessages[0]?.id
  && await ajax.patch(`${baseUrl}/v2/users/me/operation-counters`, {
    readUntilId: res.operationMessages[0]?.id
  })
  await dispatch(concatResult(res, init))
}

// 拼接结果集
const concatResult = (res: ResponseType, init = false) => async (
  dispath: ThunkDispatch<OperationMessagesRootState, void, AnyAction>,
  getState: () => OperationMessagesRootState
) => {
  const {operationMessages} = getState().operationMessages
  if (res) {
    if (!res.operationMessages || res.operationMessages.length === 0) {
      await dispath(getOperationList())
    } else {
      let allOperations: OperationMessagesItem[] = res.operationMessages.concat(operationMessages || [])
      await dispath(receivePosts({
        // init数据全部重置
        operationMessages: init ? [...(res.operationMessages || [])] : allOperations,
        // 链接信息
        links: {...res.origin?.pagination?.links},
        // 是否首次拉取数据
        isFirstFetch: init
      }))
    }
  } else {
    await dispath(requestFailed(false))
  }
}

// 更新请求中的状态
export const requestPosts: () => MESSAGE_LIST_PENDING = () => ({
  type: 'MESSAGE_LIST_PENDING',
})

export const setCurReport = (content: string) => async (
  dispath: ThunkDispatch<OperationMessagesRootState, void, AnyAction>,
  getState: () => OperationMessagesRootState) => {
  await dispath(setCurReportContent(content || getState().operationMessages.curReportContent))
}

// 拿到请求结果
export function receivePosts(
  param: Pick<MESSAGE_LIST_RECEIVE,
    Exclude<keyof MESSAGE_LIST_RECEIVE, 'type'>>
): MESSAGE_LIST_RECEIVE {
  return {
    type: 'MESSAGE_LIST_RECEIVE',
    ...param
  }
}

// 请求失败
export function requestFailed(status: boolean): MESSAGE_LIST_FAILED {
  return {
    type: 'MESSAGE_LIST_FAILED',
    status: status
  }
}

export function setCurReportContent(curReportContent: string): UPDATE_CUR_REPORT {
  return {
    type: 'UPDATE_CUR_REPORT',
    curReportContent
  }
}
